import React, { PureComponent } from 'react';
import { getSeason } from '../../../../../../lib/seasons';

import home from '../../styles.scss';


export class ClockCanvas extends PureComponent {
  /**
   * resolves on loading image from source.
   * @param {String} source of the image to load
   */
  static loadImage(source) {
    const loadImage = (resolve) => {
      const image = new Image();

      image.src = source;
      image.onload =
        () => resolve(image);
    };

    return new Promise(loadImage);
  }

  /**
   * resolves with the video image from the device
   */
  static loadVideoImage() {
    const loadVideoImage = (resolve) => {
      if (window.platform === 'ios') {
        const success =
          path => resolve(ClockCanvas.loadImage(`${path}?${Date.now()}`));

        window.camera.capture(success, console.log);
        window.camera.hide();
      } else {
        const video = document.querySelector('video');
        resolve(video);
      }
    };

    return new Promise(loadVideoImage);
  }

  constructor(props) {
    super(props);

    const season = getSeason(Date.now());

    this.state = { season };
  }


  /**
   * loads images and paints them to canvas
   */
  componentDidMount() {
    const images = [];
    if (this.props.shouldCapture) {
      ClockCanvas.loadVideoImage()
        .then((videoImage) => { // load seasonal images
          if (!videoImage) return Promise.resolve([]);
          images.push(videoImage);
          return this.loadSeasonalImages();
        })
        .then((seasonalImages) => {
          if (seasonalImages.length) images.push(...seasonalImages);
          this.paintAllImages(images);
        });
    }
  }


  /**
   * resolves with the current seasonal image overlay
   */
  loadSeasonalImages() {
    const { season } = this.state;
    if (!season || !season.overlays || !season.overlays.length) {
      return Promise.resolve([]);
    }

    return Promise.all([...season.overlays.map(overlay => ClockCanvas.loadImage(overlay))]);
  }


  /**
   * paints the iamges to the canvas
   */
  paintAllImages(images) {
    const { canvas } = this;

    if (!canvas) return;

    canvas.height = 240;
    canvas.width = 240;

    const ctx = canvas.getContext('2d');
    images.forEach(i => ctx.drawImage(i, 0, 0, canvas.width, canvas.height));

    this.props.setCanvas(canvas.toDataURL());
  }


  render() {
    if (
      !this.props.shouldCapture ||
      (!window.videostream && window.platform !== 'ios')
    ) {
      return null;
    }

    const { season } = this.state;

    let border;
    if (season && season.border) {
      const { res, className } = season.border;
      border = <img src={res} alt="Border" className={className} />;
    }

    if (window.videostream || window.platform === 'ios') {
      return (
        <div className={home.HomeCamera}>
          {border}
          <canvas
            ref={(canvas) => { this.canvas = canvas; }}
            className={home.HomeCamera__layer}
            alt="Display"
          />
        </div>
      );
    }
    return null;
  }
}


export default ClockCanvas;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/ClockIn/ClockCanvas/index.jsx